<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item link router :to="{ name: 'home' }">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Κεντρική</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <div v-if="showTransportationFeatures">
          <v-subheader>Μεταφορικό</v-subheader>


          <v-list-item link router :to="{ name: 'newtransportationdocument' }" :disabled="subscriptionExpired">
            <v-list-item-action>
              <v-icon>mdi-file-document-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Νέα φορτωτική</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link :to="{ name: 'transportationdocuments' }">
            <v-list-item-action>
              <v-icon>mdi-truck-delivery-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Λίστα φορτωτικών</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item link v-on:click="transportationExport">
            <v-list-item-action>
              <v-icon>mdi-file-excel</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Εξαγωγή αρχείου</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->


        </div>


        <div v-if="showServicesFeatures">
          <v-subheader>Υπηρεσίες</v-subheader>

          <v-list-item link router :to="{ name: 'newservicedocument' }" :disabled="subscriptionExpired">
            <v-list-item-action>
              <v-icon>mdi-file-document</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Νέο τιμολόγιο</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link router :to="{ name: 'servicedocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-file-cabinet</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Λίστα τιμολογίων</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link v-on:click="serviceExport">
            <v-list-item-action>
              <v-icon>mdi-file-excel</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Εξαγωγή αρχείου</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </div>

        <div v-if="showSalesFeatures">
          <v-subheader>Πωλήσεις Εμπορευμάτων</v-subheader>

          <v-list-item link router :to="{ name: 'newsalesdocument' }" :disabled="subscriptionExpired">
            <v-list-item-action>
              <v-icon>mdi-file-document</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Νέο τιμολόγιο</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link router :to="{ name: 'salesdocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-file-cabinet</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Λίστα τιμολογίων</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <v-subheader>Συναλασόμενοι</v-subheader>

        <v-list-item link router v-bind:to="{ name: 'customers' }" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-account-box-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Πελάτες</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-list-item link :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-account-box-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Προμηθευτές</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-list-item link router v-bind:to="{ name: 'ledgers' }" >
          <v-list-item-action>
            <v-icon>mdi-account-box-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Καρτέλες</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        
        <v-list-item link router v-bind:to="{ name: 'ledgers2' }" >
          <v-list-item-action>
            <v-icon>mdi-account-box-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Καρτέλες (2)</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-subheader>Ταμείο</v-subheader>


        

        <v-subheader>Εισπράξεις</v-subheader>


        <v-list-item link router :to="{ name: 'newincomedocument' }" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-cash</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Νέα είσπραξη</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'incomedocuments' }">
          <v-list-item-action>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Λίστα εισπράξεων</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link v-on:click="incomeExport">
            <v-list-item-action>
              <v-icon>mdi-file-excel</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Εξαγωγή αρχείου</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        <v-subheader>Πληρωμές</v-subheader>
        <!--
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-currency-eur</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Πληρωμές</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        -->

        <v-subheader>Εκτυπώσεις</v-subheader>

        <v-list-item link router :to="{ name: 'sales' }">
          <v-list-item-action>
            <v-icon>mdi-cash-register</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Πωλήσεις</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router :to="{ name: 'export-for-tms' }">
          <v-list-item-action>
            <v-icon>mdi-cash-register</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Εξαγωγή για TMS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-subheader>Ρυθμίσεις</v-subheader>

        <v-list-item link router :to="{ name: 'company' }" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-domain</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Εταιρία</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router :to="{ name: 'vehicles' }" v-if="showTransportationFeatures" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-truck</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Οχήματα</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router :to="{ name: 'documenttypes' }" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-receipt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Παραστατικά</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item link router :to="{ name: 'chargetypes' }" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-clipboard-text-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Χρεώσεις</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router :to="{ name: 'packages' }" v-if="showTransportationFeatures" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-package-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Συσκευασίες</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
  
        <v-list-item link router :to="{ name: 'products' }" v-if="showSalesFeatures" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-package-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Προϊόντα</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router :to="{ name: 'primer' }" v-if="showPrimerConfig" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Ρυθμίσεις Primer</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item link @click="logoutMethod">
          <v-list-item-action>
            <v-icon>mdi-power</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Αποσύνδεση</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="indigo" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title >{{ toolbarTitle }}</v-toolbar-title>
      
    </v-app-bar>

    <v-main>
      <v-system-bar v-if="subscriptionExpired" height="20" color="red lighten-2" dark>Η συνδρομή σας έχει λήξει, και δεν μπορείτε να δημιουργήσετε νέα παραστατικά.</v-system-bar>
      <v-system-bar v-else-if="subscriptionExpired == false && subscriptionDaysLeft < 14 && subscriptionDaysLeft >= 0" height="20" color="orange lighten-2" dark>Η συνδρομή σας θα ληξει σε {{subscriptionDaysLeft}} ημέρες.</v-system-bar>
      <v-container class="fill-height" fluid>
        <!-- 
        <v-row align="center" justify="center">
          <v-col class="text-center">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn :href="source" icon large target="_blank" v-on="on">
                  <v-icon large>mdi-code-tags</v-icon>
                </v-btn>
              </template>
              <span>Source</span>
            </v-tooltip>
          </v-col>
        </v-row>
        -->
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer color="indigo" app>
      <span class="white--text">R2026.1 &copy; CLEVER DATA ΕΕ</span>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  props: {
    source: String,
  },

  data: () => ({ drawer: true }),

  methods: {
      axiosDownload(url, filename) {
        axios({
          url: url, 
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename); //or any other extension
          document.body.appendChild(link);
          link.click();

          // link.remove();
          // url.remove();
        });
      },

      logoutMethod() {
          this.$store.dispatch('currentUser/logout')
      },

      transportationExport() {
        this.axiosDownload('/api/exports/transportation', 'τιμολόγια (φορτωτικές).xls')
      },

      serviceExport() {
        this.axiosDownload('/api/exports/service', 'τιμολόγια παροχής.xls')
      },

      incomeExport() {
        this.axiosDownload('/api/exports/income', 'αποδειξεις εισπραξης.xls')
      }
  },

  created() {
    let token = localStorage.getItem('access-token')

    if (token == null) {
      this.logoutMethod()
    } else {
      axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('access-token')}`

      axios.interceptors.response.use(function (response) {
        // Do something with response data
        return response;
      }, function (error) {
        
        if (error.response.status == 401) {
          // logoutMethod()
          console.log('not authorized -- caught by interceptor')
          // logoutMethod()
        }

        return Promise.reject(error);
      });
      // Add a 401 response interceptor
      /*
      axios.interceptors.response.use(function (response) {
          return response;
      }, function (error) {
          if (401 === error.response.status) {
              Vue.swal({
                  title: "Session Expired",
                  text: "Your session has expired. Would you like to be redirected to the login page?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  closeOnConfirm: false
              }, function(){
                  window.location = '/login';
              });
          } else {
              return Promise.reject(error);
          }
      });
      */
      //console.log('yeee-haw')
      //Vue.swal('hey!')
      this.$store.dispatch('currentUser/getCurrentUser')
      
    }
  },

  computed: {
    toolbarTitle: {
      get() {
        // return ''
        let user = this.$store.state.currentUser.user

        if (user)
          return `${user.name} (${user.company.name})`
        else
          return ''
      }
    },

    subscriptionExpired: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user)
          return user.subscription_expired
        else
          return false
      }
    },

    subscriptionDaysLeft: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user)
          return user.subscription_days_left
        
        return -1
      }
    },

    showServicesFeatures: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.services_features === true)
          return true

        return false
      }
    },

    showTransportationFeatures: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.transportation_features === true)
          return true

        return false
      }
    },

    showSalesFeatures: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.sales_features === true)
          return true

        return false
      }
    },

    showPrimerConfig: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.show_primer_menu === true || user.company.use_primer === true)
          return true

        return false
      }
    }
  }
};
</script>
